import React from 'react'
import { AmountCardProps } from '../../../types'
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

const AmountCard: React.FC<AmountCardProps> = ({ 
  label, 
  amount, 
  icon, 
  showRupeeSymbol = true, 
  onClick, 
  isHover = true,
  active = false 
}) => {
    const formatAmount = (value: number): string => {
        return value.toLocaleString('en-IN');
    }
    return (
        <Card
            variant='outlined'
            sx={{
                borderRadius: 1.2,
                borderColor: active ? 'gray' : '#e0e0e0',
                borderWidth: active ? 2 : 1,
                height: '100%',
                width: '100%',
                cursor: isHover ? 'pointer' : 'default',
                // backgroundColor: active ? 'rgba(25, 118, 210, 0.04)' : 'transparent',
                ...(isHover && {
                    '&:hover': { 
                        boxShadow: 1,
                        // borderColor: '#1976d2'
                        borderColor: 'gray'
                    }
                })
            }}
            onClick={onClick}
        >
            <CardContent >
                <Stack spacing={1}>
                    <Box display={'flex'} alignItems={'center'} gap={1}>
                        {icon && (
                            <Box sx={{ color: '#1976d2' }}>
                                {icon}
                            </Box>
                        )}
                        <Typography variant='body2' color='text.secondary'>
                            {label}
                        </Typography>
                    </Box>
                    <Typography variant='h5' fontWeight={600} color={active ? 'primary.main' : 'text.primary'}>
                        {showRupeeSymbol && '₹'}
                        {formatAmount(amount as number)}
                    </Typography>
                </Stack>
            </CardContent>
        </Card>
    )
}

export default AmountCard;